import { Component, OnInit, Input, ElementRef } from '@angular/core';

//import * as jquery from 'jquery';
//import * as Slick from 'slick-carousel';

declare var jQuery: any;

@Component({
  selector: 'app-slick-carousel',
  templateUrl: './slick-carousel.component.html',
  styleUrls: ['./slick-carousel.component.scss']
})
export class SlickCarouselComponent implements OnInit {

  @Input() options: any;
  $element: any;

  defaultOptions: any = {
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    centerMode: true,
    centerPadding: '60px',
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 3
        }
      },
      {
        breakpoint: 480,
        settings: {
          arrows: false,
          centerMode: true,
          centerPadding: '40px',
          slidesToShow: 1
        }
      }
    ]
  };

  constructor(private el: ElementRef) {
  }

  ngAfterContentInit() {
    for (var key in this.options) {
      this.defaultOptions[key] = this.options[key];
    }
    this.$element = jQuery(this.el.nativeElement).slick(this.defaultOptions);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/slick-carousel/slick-carousel.component.ts